__webpack_require__.p = "/wayland-explorer-cn/";